import React, { useContext, useLayoutEffect } from 'react';
import BetsOddsHeader from '../../common/BetsOddsHeader';
import MainContext from '../../contexts/MainContext';
import PrematchContext from '../../contexts/PrematchContext';
import PrematchHomeContext from '../../contexts/PrematchHomeContext';
import { SeoContext } from '../../data/seo/SeoContextProvider';
import { handleCanonicalUrl } from '../../data/seo/seoUtils';
import { getLabel } from '../../InitData';
import { adjustOddsAlignment } from '../../tables-utils';
import PrematchTournamentMatch from './PrematchTournamentMatch';

function PrematchTournamentDay(props) {
    const mainContext = React.useContext(MainContext);
    const prematchContext = React.useContext(PrematchContext);
    const prematchHomeContext = useContext(PrematchHomeContext);
    const seoContext = React.useContext(SeoContext);

    function handleHistory(url, matchPath) {
        if (window.history) {
            seoContext.refreshPathname(matchPath,mainContext.currentSection.current);
            handleCanonicalUrl(url);
            if(mainContext.historyNavigationEnabled){
                if(window.location.pathname != url) {
                    window.history.pushState(window.history.state, null, url);
                }
            }else{
                window.history.replaceState(window.history.state, null, url);
            }
        }
    }

    function openMatch(match, url, matchPath) {
        prematchHomeContext.changeMatch(match,props.isLive || false);
        if (!window.appConfig.SHOP_MODE) {
            handleHistory(url,matchPath);        	
        }
    }

    const matches = props.matches;
    const firstMatch = matches[0];

    useLayoutEffect(() => {
        adjustOddsAlignment();
    });

    let fiveColumnTemplate = false;
    if (firstMatch.gruppiScommessa.length <= 1 && !firstMatch.isLive && firstMatch.avvRef == null) {
        fiveColumnTemplate = true;
    }
    
    return (
        <>
            {/* <div className="bg-grigio bianco data-partite pointer toggle-nascondi-live" data-toggle="collapse" data-target={"#prematch-matches-container-" + props.tournament.uniqueId + '-' + props.id}>{matches[0].date}</div> */}
            <div /* className="collapse show" */>
                <div className="contenitore-table bg-bianco collapse show bordo-tondo" id={`prematch-matches-container-${props.tournament.uniqueId}-${props.id}`}>
                    <div className={`tabellaQuoteIntestazione text_s1 tabellaQuoteIntestazionePrematch mb-2${fiveColumnTemplate ? ' tabellaQuotePrematch_5col' : ''}`}>
                        <div className="tabellaQuoteAlias d-flex justify-content-center align-items-center">{getLabel('prematch_page.torneo.tournament_day_header.alias')}</div>
                        <div className="tabellaQuoteTempo d-flex justify-content-center align-items-center pointer">
                            <div className={"sortContainer sortedUp"}>
                                <i className="fas fa-sort-up"></i>
                                <i className="fas fa-sort-down"></i>
                            </div>
                            <p>{getLabel('prematch_page.torneo.tournament_day_header.time')}</p>
                        </div>
                        <div className="tabellaQuoteSquadre"></div>
                        <div className="tabellaQuoteData pl-2" >{firstMatch.date}</div>
                        <div className="tabellaQuoteContenitoreQuotazioni d-flex justify-content-end align-items-center flex-grow-1">
                            <BetsOddsHeader bets={props.headerBets} matches={matches} />
                        </div>
                        <div className="tabellaQuoteStatistiche"></div>
                        <div className="tabellaQuoteAltre d-flex justify-content-center align-items-center"></div>
                    </div>
                    {matches.map(match => {
                        function handleClick(match, url, matchPath) {
                            openMatch(match, url, matchPath);
                        }
                        const highlight = prematchContext.match?.uniqueId === match.uniqueId ?? false;
                        return (
                            <PrematchTournamentMatch key={match.id} match={match} aggregata={props.aggregata} openMatch={handleClick} isLive={props.isLive} highlight={highlight} />
                        );
                    })}
                </div>
            </div>
        </>
    )
}

export default PrematchTournamentDay;